import {AssistanceApplicationType} from '../../services/api.client';

export const FundAdministrativeAgencyNameMap: { [key in AssistanceApplicationType]: string } = {
    [AssistanceApplicationType.UHONS]: 'UHONS',
    [AssistanceApplicationType.UFF]: 'UFF',
    [AssistanceApplicationType.STLWater]: 'STLWater',
    [AssistanceApplicationType.EFN]: 'EFN',
    [AssistanceApplicationType.STLStorm]: 'STLStorm',
};

export const FundAdministrativeAgencyName = 'UHONS';
